import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useMutation } from '@sequencehq/api/utils'
import { useNotifications } from '@sequencehq/core-components'
import { logError } from '@sequencehq/utils'

export function useMarkTaxCategoryAsDefault() {
  const { displayNotification } = useNotifications()

  const { mutateAsync: markTaxCategoryAsDefault } = useMutation(
    dashboardv99990101Client.postSetTaxCategoryAsDefault,
    {
      onSuccess: data => {
        displayNotification(`${data?.name} marked as default`, {
          type: 'success'
        })
      },
      onError: err => {
        displayNotification('Failed to mark tax rate as default', {
          type: 'error'
        })

        logError(err)
      }
    }
  )

  return async (taxCategoryId: string) => {
    await markTaxCategoryAsDefault({
      id: taxCategoryId
    })
  }
}
